import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/$webinarId/marketing/$id/select-list')({});
